// eslint-disable-next-line no-restricted-imports
import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';

import type { StatsigOptions } from './initializeClientWithProvider.ts';

export function getFeatureFlagsServiceApiKey(
	confluenceEnvironment: StatsigOptions['environment'],
): string {
	// see http://go/fx3/resources/api-keys
	switch (confluenceEnvironment) {
		case 'PRODUCTION':
		case 'prod':
			return isFedRamp()
				? 'bfa7d1a5-f85f-45ae-8dd1-ce35820db2ca'
				: '5f23756f-37cc-4259-8261-3e4e081559c8';
		case 'STAGING':
		case 'staging':
			return isFedRamp()
				? '12825e24-5928-40bf-98d8-ad76ac07060a'
				: '48512e86-2695-4b50-a4c5-da6bb1bcd591';
		case 'DEVELOPMENT':
		default:
			return 'f10b0994-2e84-4eb9-a02a-ac9cb34c954d';
	}
}
